import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user p-mr-3" })
], -1)
const _hoisted_3 = {
  key: 0,
  class: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!

  return (_openBlock(), _createBlock(_component_FloatLabel, {
    label: _ctx.label || _ctx.$t(`user_autocomplete.label`)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_AutoComplete, _mergeProps(_ctx.$attrs, {
        dropdown: "",
        completeOnFocus: "",
        modelValue: _ctx.searchBox,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchBox = $event)),
        suggestions: _ctx.suggestions,
        field: _ctx.selectedLabel,
        minLength: 2,
        label: _ctx.$t(`user_autocomplete.placeholder`),
        onItemSelect: _ctx.onSelect,
        onComplete: _ctx.search
      }), {
        item: _withCtx(({item}) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _hoisted_2,
              _createElementVNode("span", null, _toDisplayString(item.name) + " " + _toDisplayString(item.surname), 1)
            ]),
            (_ctx.showStatus)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("span", {
                    class: _normalizeClass(`user_status status_${item.status}`)
                  }, _toDisplayString(_ctx.$t(`user.status_${item.status}`)), 3)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 16, ["modelValue", "suggestions", "field", "label", "onItemSelect", "onComplete"])
    ]),
    _: 1
  }, 8, ["label"]))
}